export const GET_STIPEND = 'GET_STIPEND'
export const GET_STIPEND_GROUPS = 'GET_STIPEND_GROUPS'
export const GET_STIPEND_FACULTIES = 'GET_STIPEND_FACULTIES'
export const GET_STIPEND_PREPARATION_TYPES = 'GET_STIPEND_PREPARATION_TYPES'
export const DELETE_STIPEND = 'DELETE_STIPEND'
